import React from 'react';

const Test = () => {
  return <div></div>;
};

// const generateRandom = useCallback((max) => {
//   return Math.floor(Math.random() * max);
// }, []);

// const makeRandom = useCallback(
//   (max, length) => {
//     const array = [];
//     for (let i = 0; i < length; i++) {
//       array.push(generateRandom(max));
//     }
//     return array;
//   },
//   [generateRandom]
// );

// const colorFunction = useCallback(() => {
//   const randomNumber = generateRandom(6);
//   switch (randomNumber) {
//     case 0:
//       return ['rgb(255, 99, 132)', 'rgba(255, 99, 132, 0.4)'];
//     case 1:
//       return ['rgb(255, 159, 64)', 'rgba(255, 159, 64, 0.4)'];
//     case 2:
//       return ['rgb(82, 214, 107)', 'rgba(82, 214, 107, 0.4)'];
//     case 3:
//       return ['rgb(0, 255, 213)', 'rgba(0, 255, 213, 0.4)'];
//     case 4:
//       return ['rgb(75, 192, 192)', 'rgba(75, 192, 192, 0.4)'];
//     case 5:
//       return ['rgb(153, 102, 255)', 'rgba(153, 102, 255, 0.4)'];
//     default:
//       return;
//   }
// }, [generateRandom]);

export default Test;
